import React from 'react';
import PropTypes from 'prop-types';
import './ContactInformationPopup.css';
import ContactOption from './../../ProjectManagement/ContactOption';

export const ContactInformationPopup = ({
  handleAddContactInfo,
  handleNextStep,
  handleChange,
  user,
}) => (
  <div className="contact-information-popup">
    <ContactOption
      phone_number_ddi="+1"
      handleAddContactInfo={handleAddContactInfo}
      handleNextStep={handleNextStep}
      handleChange={handleChange}
      user={user}
    />
  </div>
);

ContactInformationPopup.propTypes = {
  handleAddContactInfo: PropTypes.func,
  handleNextStep: PropTypes.func,
  handleChange: PropTypes.func,
  user: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Popup/ContactInformationPopup/ContactInformationPopup.js